import React from 'react'
import './OrganizationForm.css'

/** OWN COMPONENTS */
import PopUp from '../../PopUpNotification/PopUp'

/** IMPORT REACT TOOLBOX COMPONENTS */
import Button from 'react-toolbox/lib/button/Button';
import IconButton from "react-toolbox/lib/button/IconButton"
import Input from "react-toolbox/lib/input/Input"
import Autocomplete from 'react-toolbox/lib/autocomplete/Autocomplete';
import List from 'react-toolbox/lib/list/List'
import ListItem from 'react-toolbox/lib/list/ListItem'
import Chip from 'react-toolbox/lib/chip';
import Dialog from 'react-toolbox/lib/dialog/Dialog';

/*** REDUX  ****/
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import * as OrganizationActions from "../../../../actions/organizations";

/*** REDUX ACTINS ***/
import '../../../../assets/react-toolbox/theme.css';
import {Link} from "react-router-dom";


class UserListForm extends React.Component {
    constructor() {
        super();
        this.state = {
            newUser: false,
            addIcon: "person_add",
        }
    }

    handleAddUser() {
        if (this.state.newUser) {
            this.setState({...this.state, newUser: false, addIcon: "person_add"});
        } else {
            this.setState({...this.state, newUser: true, addIcon: "close"});
        }
    }

    handleChange(name, value) {

        let index = this.props.noUsers.findIndex(entity => entity.email === value);

        if (index >= 0) {
            let user = {
                name: this.props.noUsers[index].id,
                isAdmin: false
            };

            this.props.organizationActions.postUserOrg(this.props.shortName, user, (response, err) => {
                if (err) {
                    console.log("ERROR -> " + response);
                    this.errorPopUp('User role has not been changed', "");
                }
                this.handleAddUser();
            });

        } else {
            this.handleAddUser();
        }
    };

    errorPopUp(title, msg) {
        this.props.errorPopUp(title, msg);
    }

    handleDelete(user) {
        this.props.organizationActions.delUserOrg(this.props.shortName, user, (response, err) => {
            if (err) {
                console.log("ERROR -> " + response);
                this.errorPopUp('User role has not been changed', "");
            }
        });
    }

    handleUser(id) {

        let index = this.props.users.findIndex(entity => entity.user_id === id);

        if (index >= 0) {

            let user = {
                name: this.props.users[index].user_id,
                isAdmin: !this.props.users[index].isAdmin
            };

            this.props.organizationActions.postUserOrg(this.props.shortName, user, (response, err) => {
                if (err) {
                    console.log("ERROR -> " + response);
                    this.errorPopUp('User role has not been changed', "");
                }
            });

        }
    }

    handleDetail(user) {
        this.props.handleDetail(user);
    }

    handleUsers() {

        return this.props.users.map((user, key) => {
            return (
                <ListItem
                    key={key}
                    caption={user.username}
                    rightActions={[
                        <IconButton
                            key={`inf_${key}`}
                            icon={this.props.isAdmin ? (user.isAdmin ? null : 'perm_device_information') : null}
                            primary
                            onClick={this.handleDetail.bind(this, user)}
                            disabled={!this.props.isAdmin}
                        />,
                        <IconButton
                            key={`adm_${key}`}
                            icon={user.isAdmin ? 'how_to_reg' : 'person'}
                            primary
                            onClick={this.handleUser.bind(this, user.user_id)}
                            disabled={!this.props.isAdmin || (this.props.user_id === user.user_id && !this.props.global_admin)}
                        />,
                        <IconButton
                            key={`del_${key}`}
                            icon={this.props.isAdmin ? "delete" : null}
                            primary
                            onClick={this.handleDelete.bind(this, user)}
                            disabled={!this.props.isAdmin || (this.props.user_id === user.user_id && !this.props.global_admin)}
                        />
                    ]}
                    onClick={this.handleDetail.bind(this, user)}
                />
            );
        });
    }

    render() {

        return (
            <div>
                {(this.props.noUsers.length > 0 && this.props.global_admin) && <IconButton primary
                                                             className="buttonClose"
                                                             icon={this.state.addIcon}
                                                             onClick={this.handleAddUser.bind(this)}
                />}
                {!this.props.global_admin && this.props.isAdmin &&
                <Link to={'/organization/user/new/'+ this.props.orgId} >
                <IconButton primary
                            className="buttonClose"
                            icon={this.state.addIcon}
                /></Link>}
                <h4 className="usersHeader">Users</h4>
                <List>
                    {this.handleUsers()}
                </List>
                {this.state.newUser ?
                    <Autocomplete className='inputForm' label="New User"
                                  direction={"down"}
                                  value={''}
                                  source={this.props.noUsers.map(ent => {return ent.email})}
                                  multiple={false}
                                  disabled={false}
                                  showSelectedWhenNotInSource={true}
                                  onChange={this.handleChange.bind(this, 'newUser')}
                    /> : ""}
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        organizationProp: state.organizations.currentOrganizationDetails,
        user_id: state.user.id,
        global_admin: state.user.admin

    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        organizationActions: bindActionCreators(OrganizationActions, dispatch),
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(UserListForm)



// WEBPACK FOOTER //
// ./src/components/DashBoard/AdminOrganizations/OrganizationForm/UserListForm.js